import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CommonService,
  CONSTANT,
  FileUploadService,
  LoaderService,
  ObservableService,
  OrderService,
  PdfGeneratorService,
} from '@bst-frontend/shared';
import { finalize } from 'rxjs';

@Component({
  selector: 'bst-frontend-update-lr',
  templateUrl: './update-lr.component.html',
  styleUrls: ['./update-lr.component.css'],
})
export class UpdateLrComponent implements OnInit {
  /** Optional existing payload for edit/view */
  @Input() initialData?: any;

  dispatchForm!: FormGroup;

  isSubmitting = false;
  today = new Date();
  @ViewChild('lrTemplate') lrTemplate!: ElementRef<HTMLDivElement>;
  totalChargeWeight = 0;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private fileUploadService: FileUploadService,
    private loader: LoaderService,
    private orderService: OrderService,
    private observableService: ObservableService,
    public commonService: CommonService,
    private cdRef: ChangeDetectorRef,
    private pdfService: PdfGeneratorService,
    @Inject('environment') private environment: any
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  // ---------- FORM BUILDING ----------

  private buildForm(): void {

    this.initialData?.deliveries?.forEach((delivery: any) => {
        delivery.items.forEach((item: any) => {
          item.planned.chargeWeight = this.commonService.getChargeWeight(item, this.initialData?.productDifferences)
          item.planned.weight = this.commonService.getWeight(item, this.initialData?.productDifferences)
          item.planned.qty = this.commonService.getQty(item, this.initialData?.productDifferences)
          this.totalChargeWeight += item.planned.chargeWeight;
        });
      });

      this.initialData?.pickup?.items?.forEach((item: any) => {
        item.planned.chargeWeight = this.commonService.getChargeWeight(item, this.initialData?.productDifferences)
        item.planned.weight = this.commonService.getWeight(item, this.initialData?.productDifferences)
        item.planned.qty = this.commonService.getQty(item, this.initialData?.productDifferences)
        this.totalChargeWeight += item.planned.chargeWeight;
      })
    this.dispatchForm = this.fb.group({
      // keep these if you need LR details, can be wired to template later
      invoiceNumber: [this.initialData?.invoiceNumber, Validators.required],
      // paymentMode: [this.initialData?.paymentMode, Validators.required],
      eWayBillNo: [this.initialData?.eWayBillNo, Validators.required],
    });
  }

  cancel(): void {
    this.activeModal.dismiss('cancel');
  }

  async onGenerateOrUpdatePdf() {
    try {
      const lrNumber = this.initialData?.truckAssignment?.lrNumber;

      // 2) build filename
      const fileName = `${lrNumber}.pdf`;

      this.cdRef.detectChanges();
      // 3) get pdf blob from template
      const pdfBlob = await this.pdfService.generatePdfFromElement(
        this.lrTemplate.nativeElement
      );

      // 4) upload to S3
      this.fileUploadService
        .uploadFileToS3(pdfBlob, fileName, 'lr', this.initialData?.orderId)
        .pipe(
          finalize(() => {
            this.loader.hide();
          })
        )
        .subscribe({
          next: ({ fileUrl, fileKey }) => {
            this.loader.hide();
          },
          error: (err) => {
            console.error('Upload error', err);
            alert('Failed to generate/upload LR PDF');
          },
        });
    } catch (e) {
      alert('Failed to generate LR PDF');
      this.loader.hide();
    }
  }

  async onSubmit() {
    if (this.dispatchForm.invalid) {
      this.dispatchForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;

    const payload: any = {
      invoiceNumber: this.dispatchForm.value.invoiceNumber,
      // paymentMode: this.dispatchForm.value.paymentMode,
      eWayBillNo: this.dispatchForm.value.eWayBillNo,
    };

    this.loader.show();
    try {
      await this.orderService
        .updateSubOrder(this.initialData._id, 'lr-number', payload)
        .toPromise();
      this.onGenerateOrUpdatePdf();
      this.activeModal.close({ status: 'saved' });
    } catch (error) {
      console.log('Error', error);
    }
    this.isSubmitting = false;
  }
}
